import React from "react";
import { connect } from "react-redux";
import WebfontLoader from "@dr-kobros/react-webfont-loader";
import { createBrowserHistory } from 'history';
import Measure from 'react-measure';

import BCLLoading from "./common/Loading/BCLLoading";

import { Configuration } from "../configs/Configuration";
import TranslationDataFetcher from "../dataFetchers/translationsDataFetcher";
import ConfigDataFetcher from "../dataFetchers/configsDataFetcher";
import {
  getBECompatibleLocale,
  prepareColorsData,
  updateFontFamily,
  notifyHeightChange,
  getFontFamilies,
  getFontFamiliesLoaderConfig,
  setUserSelectedLocale
} from '../helpers/helper';
import { setAndPrepareStateParam, getCleanURL } from "../helpers/URLHelper";

import { setQueryParams} from  "../actions/queryParamsAction";
import { enablePreview, enableEmbedMode } from "../helpers/authHelper";
import { updateFontStatus } from "../actions/fontActions";

import { PRODUCT_TYPE_CONFIG, TAG_TYPE, COLOR_PALETTE_TYPE, PREFERENCE } from "../constants/common";
import { colorsUpdated } from "../actions/configFetcherActions";
import { getPilotId } from "../helpers/userHelper";
import { fetchUserTypeDetails } from "../dataFetchers/noAuthDataFetcher";

export const withBaseContainer = (ChildComponent, productType, isPublic) => {
  class BaseContainer extends React.Component {
    constructor(props) {
      super(props);
      this.configuration = Configuration.getConfiguration();
      this.fontConfig = {};
      this.fontLoadCallback = this.fontLoadCallback.bind(this);
    }

    componentDidMount() {
      const browserHistory = createBrowserHistory();
      let userId;
      if (!this.props.isPublic) {
        userId = this.props.userIdentityDetails.userId;
      }
      browserHistory.listen((location, action)=>{
        if(action === "POP"){
          this.updateURL(false);
        }
      });

      if(this.configuration.preview){
        enablePreview();
      }
      //set if it's embed mode
      if (this.configuration.embed) {
        enableEmbedMode();
      }
      this.props.fetchConfigData({ pilotId: getPilotId(), configType: PRODUCT_TYPE_CONFIG[productType], isPublic: this.props.isPublic});
      this.props.fetchColorPaletteData({ pilotId: getPilotId(), paletteType: COLOR_PALETTE_TYPE[productType], isPublic: this.props.isPublic});
      if(!this.props.isPublic && !this.props.userTypeDetails.details){
        this.props.fetchUserTypeDetails(userId);
      }
      if (!this.props.isPublic) {
        this.props.fetchLanguagePreference(this.props.userIdentityDetails.userId);
      }

      this.updateURL(true);
    }

    componentDidUpdate(prevProps) {
      if (!prevProps.configs.data && this.props.configs && this.props.configs.data) {
        this.updateFavicon(this.props.configs.data);
      }
      //If Language Settings Page has been enabled only then we will enable the feature of setting the user's locale as the one fetched from the API
      if ((!prevProps.configs.data || !prevProps.configs.languagesList) && this.props.configs.languagesList && this.props.configs.data
        && this.props.configs.data.preferencesTabs && this.props.configs.data.preferencesTabs.indexOf(PREFERENCE.TABS.SETTINGS) !== -1) {
          setUserSelectedLocale(this.props.configs.languagesList);
      }

      //Configs data will be available for public APIs but languageList will not be there. So if isPublic is true, ignore the languagesList
      if ((!prevProps.configs.data || (!this.props.isPublic && !prevProps.configs.languagesList)) && this.props.configs && this.props.configs.data && (this.props.isPublic || this.props.configs.languagesList) ) {
        let locale = getBECompatibleLocale(this.props.configs.data);

        this.props.fetchAllTranslations({ pilotId: getPilotId(), locale: locale, tagType: TAG_TYPE[productType], isPublic: this.props.isPublic});
        updateFontFamily(getFontFamilies(this.props.configs.data.font_family));
        this.fontConfig = getFontFamiliesLoaderConfig(this.props.configs.data.font_config)
      }

      if ((!prevProps.configs.data || !prevProps.configs.colorPallete) && this.props.configs.colorPallete && !this.props.configs.colorsUpdated) {
        prepareColorsData(this.props.configs.colorPallete, COLOR_PALETTE_TYPE[productType]);
        this.props.colorsUpdated();
      }
    }

    updateFavicon(configs) {
      let link = document.createElement('link');
      let oldLink = document.getElementById('favicon');
        link.id = 'favicon';
        link.rel = 'icon';
        link.href = configs.favicon;
        if (oldLink) {
        document.head.removeChild(oldLink);
        }
        document.head.appendChild(link);
    }

    updateURL(changeURL){
      const {location} = this.props;
      let queryParamsObj = setAndPrepareStateParam(location, false);
      if (Object.keys(queryParamsObj).length > 0) {
        this.props.setQueryParams(queryParamsObj);
      }
      if(changeURL){
        this.props.history.push(getCleanURL(location));
      }
    }

    fontLoadCallback(status) {
      this.props.updateFontStatus(status);
    }

    render() {
      const {configs, translationsData, userTypeDetails} = this.props;
      return (
        <>
          { configs && configs.data && configs.colorPallete && translationsData && translationsData.data && configs.colorsUpdated && (this.props.isPublic || userTypeDetails.details) && (this.props.isPublic || configs.languagesList) ?
            <Measure
              bounds
              onResize={contentRect => {
                setTimeout(() => {
                  notifyHeightChange(this.props.queryParams['widgetId'], contentRect.bounds.height);
                }, 100);
              }}
            >
            {({ measureRef }) => (
              <div ref={measureRef}>
                <WebfontLoader config={this.fontConfig} onStatus={this.fontLoadCallback}>
                  <ChildComponent {...this.props} />
                </WebfontLoader>
            </div>
            )}
            </Measure>
          :
            <BCLLoading />
          }
        </>
      );
    }
  }

  const mapStateToProps = state => {
    return {
      userObject: state.userObject,
      userIdentityDetails: state.userIdentityDetails,
      configs: state.configs,
      translationsData: state.translationsData,
      queryParams: state.queryParams,
      userTypeDetails : state.userTypeDetails,
      userIdentityDetails: state.userIdentityDetails,
    }
  };

  const mapDispatchToProps = dispatch => {
    return {
      fetchConfigData: options => dispatch(ConfigDataFetcher.fetchConfigData(options)),
      fetchAllTranslations: options => dispatch(TranslationDataFetcher.fetchAllTranslations(options)),
      fetchColorPaletteData: options => dispatch(ConfigDataFetcher.fetchColorPaletteData(options)),
      setQueryParams: queryParamsObj => dispatch(setQueryParams(queryParamsObj)),
      updateFontStatus: (payload) => dispatch(updateFontStatus(payload)),
      colorsUpdated : () => dispatch(colorsUpdated()),
      fetchUserTypeDetails: (uuid) => dispatch(fetchUserTypeDetails(uuid)),
      fetchLanguagePreference: uuid => dispatch(ConfigDataFetcher.fetchLanguagePreference(uuid))
    };
  };

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(BaseContainer);
}
